module.exports = __webpack_public_path__ + "static/img/qr-icon.9861834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/qr-icon.jpg
// module id = Axq0
// module chunks = 216